import { Layout } from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { useSettingValue } from "utils/Hooks";
import { useEnableSankhyaMenu } from "utils/useEnableSankhyaMenu";
import { basename } from "../../../utils/Url";

const { Sider } = Layout;

export const SankhyaSideMenu: React.FC = () => {
  const [collapsed, setCollapsed] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const authDomain = useSettingValue("REACT_APP_AUTH_DOMAIN");
  const sideMenuEnabled = useSettingValue("SHOULD_SHOW_SIDE_MENU");
  const { enableSankhyaMenu } = useEnableSankhyaMenu(authDomain);

  const handleIFrameMessage = useCallback(
    (event: MessageEvent) => {
      const allowedOrigins = [
        authDomain ? new URL(authDomain).origin : null
      ].filter(Boolean);

      if (!allowedOrigins.includes(event.origin)) {
        console.warn("Mensagem de origem não confiável:", event.origin);
        return;
      }

      if (event.data.data && event.data.data.extra !== undefined) {
        setCollapsed(
          event.data.data.extra.collapsed !== undefined
            ? event.data.data.extra.collapsed
            : true
        );
        setIsLoading(
          event.data.data.extra.isLoading !== undefined
            ? event.data.data.extra.isLoading
            : true
        );
      }

      if (event.data.type === "NAVIGATE_TO_SYSTEM") {
        window.location.href = event.data.data.url;
      }
    },
    [authDomain]
  );

  // Listen for messages from the iframe
  useEffect(() => {
    window.addEventListener("message", handleIFrameMessage);

    return () => {
      window.removeEventListener("message", handleIFrameMessage);
    };
  }, [handleIFrameMessage]);

  if (!sideMenuEnabled || !enableSankhyaMenu) {
    return null;
  }

  return (
    <Sider
      ref={iframeRef}
      width={256}
      collapsedWidth={64}
      collapsed={collapsed}
      style={{
        overflow: "hidden",
        height: "100%",
        position: "fixed",
        left: 0,
        top: 0,
        bottom: 0,
        backgroundColor: "#fff",
        boxShadow: "2px 0 6px rgba(0,0,0,0.1)",
        zIndex: 1001
      }}
    >
      <iframe
        hidden={isLoading}
        id="sankhya-menu-iframe"
        title="side-menu"
        style={{
          height: "100%",
          border: "none",
          position: "absolute",
          overflowY: "hidden",
          left: 0,
          top: 0
        }}
        src={`${authDomain}${basename.slice(
          1
        )}/side_menu_sankhya/?original_name=organograma`}
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads allow-top-navigation allow-popups-to-escape-sandbox"
        allowFullScreen
      />
    </Sider>
  );
};
